<template>
  <div class="welcome-home">
    <div class="welcome-header"></div>
    <div class="welcome">
      <div class="box">
        <div class="box-content">
          <div class="ncp-logo">
          </div>
          <p class="welcome-title1">Welcome! <br>Data Center</p>
          <br/>
          <br/>
          <p>
            {{$t('message.welcomeMessage')}}
          </p>
        </div>
        <div class="box-bottom">
          <div class="lang"><i class="icon-global"></i></div>
          <router-link :to="{ path: '/request', query: { flow: 'visit' } }" class="btn lg point">방문신청</router-link>
          <router-link :to="{ path: '/request', query: { flow: 'workPermit' } }" class="btn lg white point">안전작업허가</router-link>
<!--          <router-link to="check" class="btn lg white point">신청확인</router-link>-->
        </div>
      </div>

    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  components: {
  },
  mounted(){
    if (screen.width < 768) {
        var mvp = document.getElementById('myViewport');
        mvp.setAttribute('content','width=device-width, initial-scale=0.8');
    }
  }
};
</script>

<style scoped>

</style>
